export default "__VITE_ASSET__CQW8BbO6__"